module.exports = __webpack_public_path__ + "static/img/戴防尘口罩.4c9980c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/warnSign/戴防尘口罩.png
// module id = 728/
// module chunks = 1